"use client";

import { ReactNode } from "react";

interface ModalSectionProps {
  title: string;
  titleClassName?: string;
  children: ReactNode;
}

export const ModalSection = ({
  title,
  titleClassName = "title_s text-content_tertiary",
  children,
}: ModalSectionProps) => {
  return (
    <div>
      <h3
        aria-label="Modal Section h3"
        data-openreplay-label="Modal Section h3 Semantic"
        id="sem-modal-section-h3"
        className={`${titleClassName} mb-4`}
      >
        {title}
      </h3>
      {children}
    </div>
  );
};
